import { FC } from 'react';

import { Image } from '@shared/api/media/media.interface';
import { fileBucketUrl } from '@shared/utils/fileUtils';

interface SignatureViewModalProps {
  signatureImage: Image;
  onClose: () => void;
}

export const SignatureViewModal: FC<SignatureViewModalProps> = ({
  signatureImage,
  onClose,
}) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="mx-4 w-full max-w-lg rounded-xl bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b px-5 py-4">
          <div>
            <h3 className="text-lg font-bold text-gray-800">서명 확인</h3>
            <p className="text-xs text-gray-500">
              서명일: {new Date(signatureImage.createdAt).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
            </p>
          </div>
          <button
            onClick={onClose}
            className="rounded-full p-1 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-5">
          <div className="overflow-hidden rounded-lg border-2 border-dashed border-gray-200 bg-white">
            <img
              src={fileBucketUrl(signatureImage.url, 'raw')}
              alt="수신자 서명"
              className="h-auto w-full object-contain"
            />
          </div>
        </div>
        <div className="border-t px-5 py-3">
          <button
            onClick={onClose}
            className="w-full rounded-lg bg-gray-800 py-2.5 text-sm font-medium text-white transition hover:bg-gray-900"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};
